import { hasLocalItem, readLocalItem, removeLocalItem, writeLocalItem } from '@/helpers/safeStorage'

export const TENANTS_PAGE_FILTERS_KEY = 'tenants-page-filters'

// Tous les acces passent par @/helpers/safeStorage : dans un navigateur integre, en navigation
// privee ou avec des reglages stricts, TOUCHER localStorage leve une exception. Ces exceptions
// remontaient jusqu'a l'ecran et pouvaient laisser une page blanche.

const clear = (key) => removeLocalItem(key)

const setString = (key, string) => writeLocalItem(key, string)
const setObject = (key, object) => writeLocalItem(key, JSON.stringify(object))

const hasKey = (key) => hasLocalItem(key)

const getString = (key, defaultString) => {
  if (hasKey(key)) {
    const valeur = readLocalItem(key)

    // Lecture refusee malgre la presence de la cle : on retombe sur la valeur par defaut
    // plutot que de renvoyer null, qui ferait echouer les appelants comme getBoolean.
    return valeur === null ? defaultString : valeur
  }

  return defaultString
}

const getBoolean = (key, defaultString) => {
  try {
    return JSON.parse(getString(key, defaultString))
  } catch (e) {
    // Valeur absente ou illisible : on ne laisse pas JSON.parse casser l'appelant.
    return false
  }
}

const getObject = (key, defaultObject) => {
  if (hasKey(key)) {
    try {
      return JSON.parse(readLocalItem(key))
    } catch (e) {
      return defaultObject
    }
  }

  return defaultObject
}

export const localStorageService = {
  clear,
  getBoolean,
  getObject,
  getString,
  setObject,
  setString,
  hasKey,
}
